import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function PaymentError() {
    const navigate = useNavigate();
    const location = useLocation();
    const [countdown, setCountdown] = useState(15);

    useEffect(() => {
        // استخراج المعاملات من الـ URL
        const params = new URLSearchParams(location.search);
        const orderId = params.get("order_id");

        // العد التنازلي
        const timer = setInterval(() => {
        setCountdown((prev) => {
            if (prev <= 1) {
            clearInterval(timer);
            navigate("/", {
                state: { 
                message: t('payment-error-message'),
                orderId: orderId
                }
            });
            return 0;
            }
            return prev - 1;
        });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate, location]);

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "65vh",
            flexDirection: "column",
            backgroundColor: "#f8f9fa",
            padding: "20px"
        }}>
            <div style={{
                backgroundColor: "white",
                padding: "40px",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                textAlign: "center",
                maxWidth: "500px",
                width: "100%"
            }}>
                <div style={{
                    width: "80px",
                    height: "80px",
                    backgroundColor: "#ffc107",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px"
                }}>
                    <span style={{ fontSize: "40px", color: "white" }}>!</span>
                </div>
                <h2 style={{ color: "#856404", marginBottom: "10px" }}>
                    {t('payment-error-title')}
                </h2>
                <p style={{ color: "#666", marginBottom: "20px" }}>
                    {t('payment-error-des')}
                </p>
                <p style={{ fontSize: "14px", color: "#999" }}>
                    {t('payment-error-timer-1')}{countdown} {t('payment-error-timer-2')}
                </p>
                <button
                    onClick={() => navigate("/cart")}
                    style={{
                        marginTop: "20px",
                        padding: "10px 30px",
                        backgroundColor: "#ffc010",
                        border: "none",
                        borderRadius: "6px",
                        color: "#333",
                        fontSize: "16px",
                        cursor: "pointer"
                    }}
                >
                    {t('payment-error-button')}
                </button>
            </div>
        </div>
    );
}

export default PaymentError;